// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__fD0OS","dragIcon":"SortableItem_dragIcon__TyX1t","disabled":"SortableItem_disabled__Ir8tY"};